import { render } from "./AboutUs.vue?vue&type=template&id=74290682&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=74290682&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74290682"]])

export default __exports__